export default __webpack_public_path__ + "static/media/Rule4.8c453291.png";